//https://codepen.io/maheshambure21/pen/pbYxGK
import { defineComponent } from 'vue';

export default defineComponent({
    emits: ["contextual-action"],
    data: () => ({
        ctx_tracked_items: [],
        ctx_current_uid: null,
        ctx_dom: null,
        ctx_class_css: {
            dom: "octolo-context-menu",
            sub: "octx-sub-menu",
            has: "octx-has-sub-menu",
            act: "is-active",
        }
    }),
    computed: {
        // Test
        ContextualMenuIsInit(){
            return this.ctx_dom ? true : false;
        },
        ContextualMenuListId(){
            return this.ctx_tracked_items;
        }
    },
    methods: {
        // Start Contextual Menu
        CtxMenuOpen($event, {menu, listeners_open, listeners_close, menu_data}){
            this.menu_data = menu_data;
            this.ContextualMenuOpen($event, menu, listeners_open, listeners_close);
        },

        ContextualMenuGenerateUID(){ return Math.random().toString(36).slice(2); },
        ContextualMenuReset() {},
        ContextualMenuGenerate(menu){
            this.ContextualMenuReset();
            var menuItem = document.createElement("li");

            if(menu.icon){
                const iconItem = document.createElement('i');
                iconItem.classList.add('material-symbols-outlined')
                iconItem.innerHTML = menu.icon;
                menuItem.appendChild(iconItem);
            }

            const labelItem = document.createElement('label');
            labelItem.innerHTML = menu.label

            if (menu.subMenu) {
                // Handle sub-menu
                menuItem.classList.add(this.ctx_class_css.has);
                var subMenuContainer = document.createElement("div");
                subMenuContainer.classList.add(this.ctx_class_css.sub, this.ctx_class_css.dom);

                for (var submenu of menu.subMenu)
                    subMenuContainer.appendChild(this.ContextualMenuGenerate(submenu));
                menuItem.appendChild(subMenuContainer);

                menuItem.addEventListener("mouseenter", (event) => {
                    this.ContextualMenuOpenSubMenu(event, menuItem);
                });
                menuItem.addEventListener("mouseleave", (event) => {
                    this.ContextualMenuCloseSubMenu(event, menuItem);
                });

                menuItem.appendChild(labelItem);

            } else if (typeof menu["function"] === "function") {
                // Attach click and touchend event for menu items with a function
                if (menu.input){
                    const inputItem = document.createElement('input');
                    inputItem.type = 'file';
                    inputItem.classList.add('hidden')
                    inputItem.addEventListener("change", (event) => {
                        if (event.target.files[0]) {
                            let file = event.target.files[0];
                            menu['function'](this.menu_data, file);
                            this.ContextualMenuClose();
                        }
                    });
                    labelItem.appendChild(inputItem);
                }else {
                    menuItem.addEventListener("click", () => {
                        menu['function'](this.menu_data);
                        this.ContextualMenuClose();
                    });
                }
                menuItem.appendChild(labelItem);
            }
            return menuItem;
        },
        ContextualMenuBaseGenerate(menu_config){
            this.ctx_dom.innerHTML = "";
            for (var m of menu_config)
                this.ctx_dom.appendChild(this.ContextualMenuGenerate(m));
        },


        ContextualMenuOpenSubMenu(event, menuItem) {
            var siblings = menuItem.parentNode.children;
            for (var i = 0; i < siblings.length; i++) {
                var sibling = siblings[i];
                if (sibling !== menuItem)
                    sibling.classList.remove("is-active");
            }
            menuItem.classList.add("is-active");
            if(menuItem.classList.contains(this.ctx_class_css.has)){
                var sub_menu = menuItem.querySelector(".octx-sub-menu");;
                this.ContextualSubMenuPosition(event, sub_menu);
            }
        },

        ContextualMenuCloseSubMenu(event, menuItem) {
            menuItem.classList.remove("is-active");
        },

        ContextualSubMenuCorrectPosition(event, menu_dom){
            var menuRect = menu_dom.getBoundingClientRect();
            if (menuRect.right > document.body.clientWidth) {
                const parent_width = menu_dom.parentNode.getBoundingClientRect().width;
                menu_dom.style.right = parent_width + 1 + "px";
            }
            if (menuRect.bottom > window.innerHeight) {
                menu_dom.style.top = parseInt(menu_dom.style.top) - (menuRect.bottom - window.innerHeight) - 1 + "px";
            }
        },

        ContextualSubMenuPosition(event, sub_menu){
            var sub_width = sub_menu.getBoundingClientRect().width;
            sub_menu.style.right = -sub_width+"px";
            //sub_menu.classList.add(this.ctx_class_css.act);
            this.ContextualSubMenuCorrectPosition(event, sub_menu);
        },


        ContextualMenuCorrectPosition(event, menu_dom){
            var menuRect = menu_dom.getBoundingClientRect();
            if (menuRect.right > document.body.clientWidth) {
                menu_dom.style.left = parseInt(menu_dom.style.left) - (menuRect.right - document.body.clientWidth) - 1 + "px";
            }
            if (menuRect.bottom > window.innerHeight) {
                menu_dom.style.top = parseInt(menu_dom.style.top) - (menuRect.bottom - window.innerHeight) - 1 + "px";
            }
        },
        ContextualMenuPosition(event, menu_dom){
            menu_dom.style.left = event.pageX + "px";
            menu_dom.style.top = event.pageY-5 + "px";
            menu_dom.classList.add(this.ctx_class_css.act);
            this.ContextualMenuCorrectPosition(event, menu_dom);
        },

        ContextualMenuOpen($event, menu_config, listeners_open, listeners_close){
            const config = this.ContextualMenuStart($event, menu_config, listeners_open, listeners_close);
            this.ContextualMenuBaseGenerate(config.menu_config);
            this.ContextualMenuPosition($event, this.ctx_dom);
        },
        ContextualMenuCloseOnEvent(){
            this.ContextualMenuClose();
        },
        ContextualMenuClose(){
            this.ctx_dom.classList.remove(this.ctx_class_css.act);
            this.menu_data = null;
        },

        // Event listener
        ContextualMenuStartListeners(el, lopen, lclose){
            el.addEventListener("mouseleave", this.ContextualMenuCloseOnEvent);
            for(const l of lopen)
                el.addEventListener(l, this.ContextualMenuOpen);
            for(const l of lclose)
                el.addEventListener(l, this.ContextualMenuCloseOnEvent);
        },
        ContextualMenuEndListeners(el, lopen, lclose){
            el.removeEventListener("mouseleave", this.ContextualMenuCloseOnEvent);
            var l = null;
            for(l of lopen)
                el.removeEventListener(l, this.ContextualMenuOpen);
            for(l of lclose)
                el.removeEventListener(l, this.ContextualMenuCloseOnEvent);
        },

        // Initialization
        ContextualMenuCreateDOM(){
            this.ctx_dom = document.createElement("div");
            this.ctx_dom.classList.add(this.ctx_class_css.dom);
            document.body.appendChild(this.ctx_dom);
        },
        ContextualMenuInit(cfg){
            if(!this.ContextualMenuIsInit)
                this.ContextualMenuCreateDOM();
            this.ContextualMenuStartListeners(this.ctx_dom, cfg.listeners_open, cfg.listeners_close);
        },
        ContextualMenuStart($event, menu_config, listeners_open, listeners_close){
            if(!$event.target.id){
                this.current_uid = this.ContextualMenuGenerateUID();
                var cfg = {
                    uid: this.current_uid,
                    event: $event,
                    menu_config,
                    listeners_open: listeners_open || ["contextmenu",],
                    listeners_close: listeners_close || ["click",],
                };
                this.ctx_tracked_items.push(cfg);
                this.ContextualMenuInit(cfg);
                return cfg;
            }
            this.current_uid = $event.target.id;
            return this.ctx_tracked_items.find(cfg => cfg.uid == this.current_uid);
        }
    }
});
